export default __webpack_public_path__ + "static/media/car-2.2e7602f7.svg";